import {
  LitElement,
  css,
  html,
} from "https://cdn.jsdelivr.net/gh/lit/dist@3/core/lit-core.min.js";

class SkioAddToSubscription extends LitElement {
  static styles = css`
    :host {
      --color-primary:#6941c6; 
      --color-accent: #fff;
      --color-bg: #f7f2ee; 
      --color-card-bg: #f5f5f5; 
      --color-border: #e0e0e0; 
      --color-text: #333; 
      --color-muted: #666; 
      --color-strikethrough: #999; 
      position: relative;
      display: block;
      font-family: inherit;
      font-size: 16px;
    }
    .callout {
      background: var(--color-card-bg);
      border-radius: 8px;
      padding: 24px;
      margin-bottom: 24px;
      border: 1px solid var(--color-border);
      position: relative;
    }
    .callout h3 {
      margin: 0;
      font-size: 1em;
      font-weight: 700;
      color: var(--color-text);
    }
    .callout small {
      display: block;
      margin-bottom: 16px;
    }
    .callout p {
      margin: 0 0 16px 0;
      color: var(--color-muted);
      font-size: 0.9em;
    }
    .callout-button {
      background-color: black !important;
      color: white !important;
      padding: 5px !important;
    }
    .add-to-subscription-button {
      background: var(--color-primary);
      color: var(--color-accent);
      border: none;
      border-radius: 4px;
      padding: 12px 0;
      width: 100%;
      font-size: 0.9em;
      font-weight: 700;
      cursor: pointer;
      transition: background 0.2s;
      text-transform: uppercase;
    }
    .add-to-subscription-button:hover {
      background: color-mix(in srgb, var(--color-primary) 80%, black);
    }
    dialog {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0;
      z-index: 2147483647;
      background: var(--color-accent);
      border-radius: 12px;
      border: none;
      width: 100%;
      max-width: 500px;
      padding: 0;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    }
    dialog::backdrop {
      background: rgba(0, 0, 0, 0.5);
    }
    .modal-content {
      position: relative;
    }
    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      padding: 16px 32px 16px 32px;
      border-bottom: 1px solid var(--color-border);
    }
    .modal-title {
      font-size: 1.1em;
      font-weight: 700;
      color: var(--color-text);
      margin: 0;
      line-height: 1.3;
    }
    .modal-title .date-badge {
      border: 2px solid var(--color-primary);
      border-radius: 4px;
      padding: 2px 8px;
      font-size: 0.8em;
      color: var(--color-primary);
      font-weight: 500;
      background: var(--color-accent);
      display: inline-block;
    }
    .close-button {
      background: none;
      border: none;
      font-size: 2em;
      color: var(--color-muted);
      cursor: pointer;
      padding: 0;
      margin: 0;
      width: 2em;
      height: 2em;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }
    .close-button:hover {
      color: var(--color-text);
    }
    .modal-body p {
      margin: 0;
      color: var(--skio-add-to-sub-muted);
      font-size: 0.9em;
      line-height: 1.5;
    }
    form {
      padding: 24px 32px;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .option-label {
      display: flex;
      align-items: center;
      gap: 8px;
      background: var(--color-card-bg);
      border: 1px solid var(--color-border);
      border-radius: 8px;
      padding: 12px;
      cursor: pointer;
      transition: border 0.2s, background 0.2s;
      position: relative;
    }
    .option-label:hover {
      border-color: var(--color-primary);
    }
    .option-label.selected {
      border: 2px solid var(--color-primary);
      background: var(--color-accent);
    }
    .option-label input[type="radio"] {
      accent-color: var(--color-primary);
      width: 1.5em;
      height: 1.5em;
      flex-shrink: 0;
    }
    .option-content {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      gap: 4px;
    }
    .option-title {
      font-size: 1em;
      font-weight: 700;
      color: var(--color-text);
    }
    .delivery-policy {
      font-size: 0.8em;
      color: var(--color-muted);
      font-weight: 500;
      text-transform: capitalize;
    }
    .discount-badge {
      background: var(--color-primary);
      color: var(--color-accent);
      font-weight: 700;
      border-radius: 4px;
      padding: 4px 12px;
      font-size: 0.8em;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .price-container {
      margin-left: auto;
      text-align: right;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 2px;
    }
    .original-price {
      text-decoration: line-through;
      color: var(--color-strikethrough);
      font-size: 0.9em;
      font-weight: 500;
    }
    .discounted-price {
      color: var(--color-primary);
      font-size: 1em;
      font-weight: 700;
    }
    .modal-policy {
      font-size: 0.8em;
      color: var(--color-muted);
      padding: 0px 32px 16px 32px;
    }
    .modal-footer {
      display: flex;
      gap: 16px;
      padding: 24px 32px 32px 32px;
      border-top: 1px solid var(--color-border);
    }
    .modal-footer button {
      flex: 1;
      padding: 16px 24px;
      border-radius: 4px;
      font-size: 0.9em;
      font-weight: 700;
      border: none;
      cursor: pointer;
      transition: all 0.2s;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .primary-button {
      background: var(--color-primary);
      color: var(--color-accent);
    }
    .primary-button:hover {
      background: color-mix(in srgb, var(--color-primary) 80%, black);
    }
    .secondary-button {
      background: transparent;
      color: var(--color-text);
      border: 2px solid var(--color-border);
    }
    .secondary-button:hover {
      background: var(--color-card-bg);
      border-color: var(--color-primary);
    }
    .success-screen {
      background: #e8f5e8;
      border: 2px solid #4caf50;
      border-radius: 8px;
      padding: 24px;
      margin-bottom: 24px;
      text-align: left;
    }
    .success-title {
      font-size: 1em;
      font-weight: 700;
      color: var(--color-text);
      margin: 0 0 16px 0;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .success-message {
      font-size: 0.9em;
      color: var(--color-text);
      margin: 0 0 8px 0;
      line-height: 1.4;
    }
    .success-date {
      font-weight: 700;
      color: var(--color-text);
    }
    .success-link {
      color: var(--color-primary);
      text-decoration: none;
      font-weight: 700;
      font-size: 0.9em;
      margin-top: 16px;
      display: inline-block;
      transition: color 0.2s;
    }
    .success-link:hover {
      color: color-mix(in srgb, var(--color-primary) 80%, black);
      text-decoration: underline;
    }
    .loading-spinner {
      display: inline-block;
      width: 16px;
      height: 16px;
      border: 2px solid var(--color-accent);
      border-radius: 50%;
      border-top-color: transparent;
      animation: spin 1s linear infinite;
      margin-right: 8px;
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
    .primary-button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    .error-message {
      background: #fee;
      border: 1px solid #fcc;
      border-radius: 4px;
      padding: 12px;
      margin-bottom: 16px;
      color: #c33;
      font-size: 0.9em;
      text-align: center;
    }
    /* Debug / setup mode — matches plan picker's visual language */
    .setup-mode {
      padding: 16px;
      border: 5px solid transparent;
      border-image: repeating-linear-gradient(
        -55deg,
        #000 0,
        #000 20px,
        #ffb101 20px,
        #ffb101 40px
      ) 10;
      margin-bottom: 16px;
    }

    .setup-mode-label {
      font-size: 0.75em;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 1px;
      color: #000;
      background: #ffb101;
      padding: 2px 8px;
      margin-bottom: 12px;
      display: inline-block;
    }

    .setup-mode-note {
      font-size: 0.85em;
      color: #333;
      margin: 0 0 12px 0;
    }

    .debug-mode-toggle {
      display: flex;
      gap: 8px;
      margin-bottom: 16px;
    }

    .debug-mode-toggle button {
      font-size: 0.8em;
      font-weight: 700;
      padding: 4px 12px;
      border: 2px solid #000;
      background: transparent;
      cursor: pointer;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .debug-mode-toggle button.active {
      background: #000;
      color: #fff;
    }

    .debug-modal-preview {
      border: 1px solid var(--skio-group-border-color, #e0e0e0);
      border-radius: 0;
      max-width: 500px;
      background: var(--skio-group-background-color, #fff);
      margin-top: 8px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      overflow: hidden;
    }

    @media(max-width: 500px) {
      .modal-footer {
        flex-direction: column;
        gap: 8px;
        padding: 12px 16px 16px 16px
      }
      .modal-header {
        padding: 12px 16px 12px 16px;
      }
      form {
        padding: 12px 16px;
      }
      .modal-policy {
        padding: 0px 16px 16px 16px;
      }
    }
  `;

static properties = {
  isLoading: { type: Boolean },
  isAuthenticated: { type: Boolean },
  productId: { type: String },
  product: { type: Object },
  selectedVariant: { type: Object },
  upcomingSubscription: { type: Object },
  inactiveSubscription: { type: Object },
  eligibleForSubscription: { type: Boolean },
  eligibleForOneTimeUpsell: { type: Boolean },
  selectedOption: { type: String },
  selectedSellingPlan: { type: Object },
  showSuccessScreen: { type: Boolean },
  isSubmitting: { type: Boolean },
  submitError: { type: String },
  debug: { type: Boolean },
  options: { type: String },
  debugPreviewMode: { type: String }, // "add" | "reactivate" — debug UI only
};

// Parsed options from the JSON attribute (set by liquid snippet)
get _options() {
  try {
    return JSON.parse(this.options || '{}');
  } catch {
    return {};
  }
}

get mode() {
  if (!this.isAuthenticated) return null;
  if (this.upcomingSubscription && this.eligibleForSubscription && this.selectedVariant) return "add";
  if (this.inactiveSubscription) return "reactivate";
  return null;
}

constructor() {
  super();
  this.isLoading = false;
  this.isAuthenticated = false;
  this.eligibleForSubscription = false;
  this.eligibleForOneTimeUpsell = false;
  this.selectedOption = "subscription";
  this.showSuccessScreen = false;
  this.isSubmitting = false;
  this.submitError = null;
  this.debugPreviewMode = "add";
}

async connectedCallback() {
  super.connectedCallback();
  this.debug = this.debug || !!window?.Shopify?.designMode;
  if (this.debug) return;
  await this.initialize();
  this.isLoading = false;
  this.bindFormEvents();
}

loadSDK() {
  if (window.Skio) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://cdn.skio.com/scripts/shopify/sdk/skio-latest.js";
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

/**
 * loadSDK() only waits for the script tag to load. Skio often sets
 * storefrontUser.idToken shortly after. Without a brief wait, we bail in
 * initialize() before auth exists and mode stays null forever.
 */
async waitForSkioStorefrontUser(maxMs = 10000, intervalMs = 100) {
  const likelyCustomer =
    typeof document !== "undefined" &&
    document.body?.classList?.contains("customer-logged-in");
  if (!likelyCustomer) return;

  const deadline = Date.now() + maxMs;
  while (Date.now() < deadline) {
    if (window.Skio?.storefrontUser?.idToken) return;
    await new Promise((r) => setTimeout(r, intervalMs));
  }
}

async initialize() {
  await this.loadSDK();
  await this.waitForSkioStorefrontUser();
  this.checkAuthentication();
  if (!this.isAuthenticated) return;

  this.upcomingSubscription = await this.fetchSubscription("ACTIVE");

  if (this.upcomingSubscription) {
    this.product = await this.fetchProduct();
  } else {
    this.inactiveSubscription = await this.fetchSubscription(["CANCELLED", "PAUSED"]);
  }
}

checkAuthentication() {
  this.isAuthenticated = !!window.Skio?.storefrontUser?.idToken;
}

// ─── Data fetching ────────────────────────────────────────────────────────

async fetchSubscription(status) {
  const statusFilter = Array.isArray(status)
    ? { _in: status }
    : { _eq: status };

  const isActive = status === "ACTIVE";

  const query = `
    query storefrontGetSubscription($storefrontUserId: uuid) {
      Subscriptions(where: {
        status: ${JSON.stringify(statusFilter).replace(/"([^"]+)":/g, '$1:')}
        storefrontUserId: { _eq: $storefrontUserId }
      }, order_by: {
        ${isActive ? "nextBillingDate" : "updatedAt"}: asc
      }, limit: 1) {
        id
        status
        nextBillingDate
        ${isActive ? `
        SubscriptionLines(
          where: { removedAt: { _is_null: true } }
          limit: 1
          order_by: { createdAt: asc }
        ) {
          OriginalSellingPlan {
            PricingPolicies {
              percentageOff
              fixedPrice
            }
          }
        }` : ""}
        DeliveryPolicy {
          interval
          intervalCount
        }
        BillingPolicy {
          interval
          intervalCount
        }
      }
    }
  `;

  const variables = { storefrontUserId: window.Skio?.storefrontUser?.id };

  try {
    const response = await window.Skio.graphQLRequest({ query, variables });
    const subscription = response.data.Subscriptions[0];
    if (!subscription) return null;

    if (isActive && this.isPrepaidSubscription(subscription)) return null;

    return subscription;
  } catch (error) {
    console.error("Error fetching subscription:", error);
    return null;
  }
}

async fetchProduct() {
  const query = `
    query Products($where: Product_bool_exp) {
      Products(where: $where) {
        title
        canUpsell
        oneTimeUpsellPercentageOff
        ProductVariants {
          enableOneTimeUpsell
          platformId
          price
          compareAtPrice
          SellingPlanGroupResources {
            SellingPlanGroup {
              customName
              SellingPlans {
                id
                platformId
                PricingPolicies {
                  percentageOff
                  fixedPrice
                }
                DeliveryPolicy {
                  interval
                  intervalCount
                }
              }
            }
          }
        }
      }
    }
  `;

  const variables = {
    where: {
      platformId: { _eq: `gid://shopify/Product/${this.productId}` },
    },
  };

  try {
    const response = await window.Skio.graphQLRequest({ query, variables });
    return response.data.Products[0];
  } catch (error) {
    console.error("Error fetching product:", error);
    return null;
  }
}

// ─── Form / variant binding ───────────────────────────────────────────────

bindFormEvents() {
  const variantInput = this.getVariantIdInput();
  if (!variantInput) return;

  this.updateSelectedVariant(variantInput.value);
  this.checkVariantEligibility(this.selectedVariant);
  this.checkPreviouslyAddedProducts();

  variantInput.addEventListener("change", (e) => {
    this.updateSelectedVariant(e.target.value);
    this.checkVariantEligibility(this.selectedVariant);
    this.checkPreviouslyAddedProducts();
  });
}

/** Prefer main PDP form in this product column; first global [name=id] is often upsell/Replo. */
getVariantIdInput() {
  const wrapper = this.closest("[data-product-form-wrapper]");
  const inColumn =
    wrapper?.querySelector('[data-product-form] input[name="id"]') ||
    wrapper?.querySelector('input[name="id"]');
  if (inColumn) return inColumn;
  return (
    document.querySelector('[data-product-form] input[name="id"]') ||
    document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
    document.querySelector("[name=id]")
  );
}

updateSelectedVariant(variantId) {
  const id = variantId != null ? String(variantId).trim() : "";
  const variants = this.product?.ProductVariants;
  if (!id || !variants?.length) {
    this.selectedVariant = undefined;
    return;
  }
  this.selectedVariant = variants.find(
    (v) =>
      v.platformId?.includes(id) ||
      v.platformId?.endsWith(id) ||
      String(v.platformId) === id
  );
}

checkVariantEligibility(variant) {
  if (!variant) return;
  const groups = variant.SellingPlanGroupResources;
  const groupCount = Array.isArray(groups) ? groups.length : 0;
  this.eligibleForOneTimeUpsell = Boolean(variant.enableOneTimeUpsell && this.product?.canUpsell);
  this.eligibleForSubscription = groupCount > 0;
  if (!this.eligibleForOneTimeUpsell) this.selectedOption = "subscription";
}

checkPreviouslyAddedProducts() {
  const added = window.sessionStorage.getItem("skio_upsell_added_products") || "";
  this.showSuccessScreen = added.includes(this.selectedVariant?.platformId);
}

// ─── Helpers ──────────────────────────────────────────────────────────────

isPrepaidSubscription({ DeliveryPolicy, BillingPolicy }) {
  return (
    DeliveryPolicy.interval !== BillingPolicy.interval ||
    DeliveryPolicy.intervalCount !== BillingPolicy.intervalCount
  );
}

formatDate(timestamp) {
  const date = new Date(timestamp);
  return `${date.toLocaleString("en-US", { month: "short" })} ${date.getDate()}, ${date.getFullYear()}`;
}

formatMoney(amount) {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(amount);
}

getOriginalPrice() {
  return this.selectedVariant.compareAtPrice
    ? this.formatMoney(this.selectedVariant.compareAtPrice)
    : this.formatMoney(this.selectedVariant.price);
}

getSubscriptionPrice() {
  const sellingPlanGroup = this.selectedVariant.SellingPlanGroupResources.find((group) =>
    group.SellingPlanGroup.SellingPlans.some((plan) =>
      plan.DeliveryPolicy.interval === this.upcomingSubscription.DeliveryPolicy.interval &&
      plan.DeliveryPolicy.intervalCount === this.upcomingSubscription.DeliveryPolicy.intervalCount
    )
  );

  const sellingPlan = sellingPlanGroup?.SellingPlanGroup.SellingPlans.find((plan) =>
    plan.DeliveryPolicy.interval === this.upcomingSubscription.DeliveryPolicy.interval &&
    plan.DeliveryPolicy.intervalCount === this.upcomingSubscription.DeliveryPolicy.intervalCount
  );

  if (!sellingPlan) return { discount: null, price: this.formatMoney(this.selectedVariant.price) };

  this.selectedSellingPlan = sellingPlan;
  const { percentageOff, fixedPrice } = sellingPlan.PricingPolicies[0];

  if (percentageOff) {
    return {
      discount: `${percentageOff}%`,
      price: this.formatMoney(this.selectedVariant.price * (1 - percentageOff / 100)),
    };
  }

  return {
    discount: this.formatMoney(fixedPrice),
    price: this.formatMoney(this.selectedVariant.price - fixedPrice),
  };
}

getOneTimePrice() {
  const pct = this.product.oneTimeUpsellPercentageOff;
  if (!pct) return { discount: null, price: this.formatMoney(this.selectedVariant.price) };
  return {
    discount: `${pct * 100}%`,
    price: this.formatMoney(this.selectedVariant.price * (1 - pct)),
  };
}

// ─── Modal ────────────────────────────────────────────────────────────────

openModal() {
  const dialog = this.shadowRoot.querySelector("dialog");
  if (dialog) {
    dialog.showModal();
    dialog.addEventListener("click", this.handleBackdropClick.bind(this));
  }
}

closeModal() {
  const dialog = this.shadowRoot.querySelector("dialog");
  if (dialog) {
    dialog.close();
    dialog.removeEventListener("click", this.handleBackdropClick.bind(this));
  }
}

handleBackdropClick(e) {
  if (e.target.tagName === "DIALOG") this.closeModal();
}

// ─── Actions ──────────────────────────────────────────────────────────────

async addToSubscription() {
  this.submitError = null;
  this.isSubmitting = true;

  const mutation = `
    mutation storefrontEditSubscriptionLines($input: EditSubscriptionLinesInput!) {
      editSubscriptionLines(input: $input) {
        subscriptionId
      }
    }
  `;

  const variables = {
    input: {
      subscriptionId: this.upcomingSubscription.id,
      subscriptionLinesToCreate: [{
        customAttributes: [{ key: "add-to-subscription-component", value: "true" }],
        productVariantPlatformId: this.selectedVariant.platformId,
        quantity: 1,
        isOneTimeUpsell: this.selectedOption === "one-time",
      }],
    },
  };

  try {
    await window.Skio.graphQLRequest({ query: mutation, variables });
    this.closeModal();
    const added = window.sessionStorage.getItem("skio_upsell_added_products") || "";
    window.sessionStorage.setItem(
      "skio_upsell_added_products",
      `${added}, ${this.selectedVariant.platformId}`
    );
    this.showSuccessScreen = true;
  } catch (error) {
    console.error("Error adding to subscription:", error);
    this.submitError = "Error adding to subscription. Please try again.";
  } finally {
    this.isSubmitting = false;
  }
}

async reactivate() {
  this.submitError = null;
  this.isSubmitting = true;

  const isPaused = this.inactiveSubscription.status === "PAUSED";
  const mutation = isPaused
    ? `mutation storefrontUnpauseSubscription($input: unpauseSubscriptionInput!) {
        unpauseSubscription(input: $input) { ok }
      }`
    : `mutation storefrontReactivateSubscription($input: ReactivateSubscriptionInput!) {
        reactivateSubscription(input: $input) { ok }
      }`;

  const variables = {
    input: {
      subscriptionId: this.inactiveSubscription.id,
      ...(isPaused ? {} : { newBillingDate: new Date(Date.now() + 86400000).toISOString() }),
    },
  };

  try {
    const response = await window.Skio.graphQLRequest({ query: mutation, variables });
    if (response.errors?.length) throw new Error(response.errors[0].message);
    this.closeModal();
    this.showSuccessScreen = true;
  } catch (error) {
    console.error("Error reactivating subscription:", error);
    this.submitError = "Something went wrong. Please try again.";
  } finally {
    this.isSubmitting = false;
  }
}

// ─── Render ───────────────────────────────────────────────────────────────

render() {
  if (this.debug) return this.renderDebugMode();

  if (!this.mode) return null;
  if (this.showSuccessScreen) return this.renderSuccessScreen();
  if (this.mode === "add") return this.renderAddMode();
  if (this.mode === "reactivate") return this.renderReactivateMode();
}

renderAddMode() {
  const heading = "Add to Upcoming Subscription";
  const subheading = "You can easily add this item to your upcoming subscription order.";
  const buttonText = "Add to next order and save";

  return html`
    <div class="callout">
      <h3>${heading}</h3>
      <small>${subheading}</small>
      <p>Next order on: <b>${this.formatDate(this.upcomingSubscription.nextBillingDate)}</b></p>
      <button class="callout-button" @click=${() => this.openModal()}>
        ${buttonText}
      </button>
    </div>

    <dialog>
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">
            Add to Subscription
            <span class="date-badge">${this.formatDate(this.upcomingSubscription.nextBillingDate)}</span>
          </h2>
          <button class="close-button" @click=${this.closeModal}>&times;</button>
        </div>
        <form>
          ${this.submitError ? html`<div class="error-message">${this.submitError}</div>` : null}
          ${this.eligibleForOneTimeUpsell ? this.renderOneTimeOption() : null}
          ${this.eligibleForSubscription ? this.renderSubscriptionOption() : null}
        </form>
        <div class="modal-policy">
          ${this.selectedOption === "subscription"
            ? html`<small>By clicking Add to Order, you're adding this item to your subscription. You'll be charged automatically at the listed price and frequency until canceled. All cancellations are subject to the <a href="/policies/subscription-policy">cancellation policy</a>.</small>`
            : html`<small>By selecting Add to Order, you agree to a one-time charge for this item, which will be added to your next subscription shipment. This item will not renew or be billed again. All cancellations are subject to the <a href="/policies/subscription-policy">cancellation policy</a>.</small>`}
        </div>
        <div class="modal-footer">
          <button class="primary-button" @click=${this.addToSubscription} ?disabled=${this.isSubmitting}>
            ${this.isSubmitting ? html`<span class="loading-spinner"></span>` : "ADD TO ORDER"}
          </button>
          <button class="secondary-button" @click=${this.closeModal} type="button" ?disabled=${this.isSubmitting}>
            Cancel
          </button>
        </div>
      </div>
    </dialog>
  `;
}

renderReactivateMode() {
  const isPaused = this.inactiveSubscription.status === "PAUSED";
  const title = isPaused ? "Resume Your Subscription" : "Reactivate Your Subscription";
  const description = isPaused
    ? "Your subscription is currently paused. Resume it to receive your next order."
    : "Your subscription has been cancelled. Reactivate it to continue receiving your orders.";
  const buttonLabel = isPaused ? "Resume Subscription" : "Reactivate Subscription";

  return html`
    <div class="callout">
      <h3>${title}</h3>
      <small>${description}</small>
      <button class="callout-button" @click=${() => this.openModal()}>
        ${buttonLabel}
      </button>
    </div>

    <dialog>
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">${title}</h2>
          <button class="close-button" @click=${this.closeModal}>&times;</button>
        </div>
        <div class="modal-body">
          ${this.submitError ? html`<div class="error-message">${this.submitError}</div>` : null}
          <p>
            ${isPaused
              ? "Your subscription will be resumed and your next order will be scheduled automatically."
              : "Your subscription will be reactivated and your next order will be scheduled automatically."}
          </p>
        </div>
        <div class="modal-footer">
          <button class="primary-button" @click=${this.reactivate} ?disabled=${this.isSubmitting}>
            ${this.isSubmitting ? html`<span class="loading-spinner"></span>` : buttonLabel}
          </button>
          <button class="secondary-button" @click=${this.closeModal} type="button" ?disabled=${this.isSubmitting}>
            Cancel
          </button>
        </div>
      </div>
    </dialog>
  `;
}

renderOneTimeOption() {
  const { discount, price } = this.getOneTimePrice();
  const isSelected = this.selectedOption === "one-time";
  const title = "Get One-Time";

  return html`
    <label class="option-label ${isSelected ? "selected" : ""}" @click=${() => (this.selectedOption = "one-time")}>
      <input type="radio" name="addType" value="one-time" .checked=${isSelected} @change=${() => (this.selectedOption = "one-time")} />
      <div class="option-content">
        <span class="option-title">${title}</span>
      </div>
      ${discount ? html`<span class="discount-badge">Save ${discount}</span>` : null}
      <div class="price-container">
        ${this.getOriginalPrice() !== price ? html`<span class="original-price">${this.getOriginalPrice()}</span>` : null}
        <span class="discounted-price">${price}</span>
      </div>
    </label>
  `;
}

renderSubscriptionOption() {
  const { discount, price } = this.getSubscriptionPrice();
  const isSelected = this.selectedOption === "subscription";
  const title = "Subscribe";

  return html`
    <label class="option-label ${isSelected ? "selected" : ""}" @click=${() => (this.selectedOption = "subscription")}>
      <input type="radio" name="addType" value="subscription" .checked=${isSelected} @change=${() => (this.selectedOption = "subscription")} />
      <div class="option-content">
        <span class="option-title">${title}</span>
        <div class="delivery-policy">
          Every ${this.upcomingSubscription.DeliveryPolicy.intervalCount}
          ${this.upcomingSubscription.DeliveryPolicy.interval.toLowerCase()}
        </div>
      </div>
      ${discount ? html`<span class="discount-badge">Save ${discount}</span>` : null}
      <div class="price-container">
        ${this.getOriginalPrice() !== price ? html`<span class="original-price">${this.getOriginalPrice()}</span>` : null}
        <span class="discounted-price">${price}</span>
      </div>
    </label>
  `;
}

renderSuccessScreen() {
  const isReactivate = this.mode === "reactivate" || !!this.inactiveSubscription;
  const isPaused = this.inactiveSubscription?.status === "PAUSED";

  if (isReactivate) {
    return html`
      <div class="success-screen">
        <h2 class="success-title">${isPaused ? "Subscription Resumed" : "Subscription Reactivated"}</h2>
        <p class="success-message">
          Your subscription has been ${isPaused ? "resumed" : "reactivated"}. Your next order will be processed on the next scheduled billing date.
        </p>
        <a href="/a/account/subscriptions" class="success-link">View and manage my subscriptions -></a>
      </div>
    `;
  }

  return html`
    <div class="success-screen">
      <h2 class="success-title">Added to Your Next Order</h2>
      <p class="success-message">
        This item will be included in your next subscription order shipment on
        <span class="success-date">${this.formatDate(this.upcomingSubscription.nextBillingDate)}</span>
      </p>
      <a href="/a/account/subscriptions" class="success-link">View and manage my subscriptions -></a>
    </div>
  `;
}

renderDebugMode() {
  const mockDate = new Date();
  mockDate.setDate(mockDate.getDate() + 30);
  const formattedDate = this.formatDate(mockDate);

  const heading = "Add to Upcoming Subscription";
  const subheading = "You can easily add this item to your upcoming subscription order.";
  const buttonText = "Add to next order and save";
  const oneTimeTitle = "Get One-Time";
  const subscriptionTitle = "Subscribe";

  return html`
    <div class="setup-mode">
      <div class="setup-mode-label">Setup Mode — Skio Add to Subscription</div>
      <p class="setup-mode-note">
        UI preview with mock data. Functionality requires an authenticated customer with an active or inactive subscription.
      </p>

      <div class="debug-mode-toggle">
        <button
          class="${this.debugPreviewMode === "add" ? "active" : ""}"
          @click=${() => (this.debugPreviewMode = "add")}
          type="button"
        >Add Mode</button>
        <button
          class="${this.debugPreviewMode === "reactivate" ? "active" : ""}"
          @click=${() => (this.debugPreviewMode = "reactivate")}
          type="button"
        >Reactivate Mode</button>
      </div>

      ${this.debugPreviewMode === "add"
        ? html`
          <div class="callout" style="margin-bottom: 16px;">
            <h3>${heading}</h3>
            <small>${subheading}</small>
            <p>Next order on: <b>${formattedDate}</b></p>
            <button class="callout-button" type="button">${buttonText}</button>
          </div>

          <div class="debug-modal-preview">
            <div class="modal-content">
              <div class="modal-header">
                <h2 class="modal-title">
                  Add to Subscription
                  <span class="date-badge">${formattedDate}</span>
                </h2>
                <button class="close-button" type="button">&times;</button>
              </div>
              <form>
                <label class="option-label">
                  <input type="radio" name="addType" value="one-time" />
                  <div class="option-content">
                    <span class="option-title">${oneTimeTitle}</span>
                  </div>
                  <span class="discount-badge">Save 10%</span>
                  <div class="price-container">
                    <span class="original-price">$34.99</span>
                    <span class="discounted-price">$31.49</span>
                  </div>
                </label>
                <label class="option-label selected">
                  <input type="radio" name="addType" value="subscription" checked />
                  <div class="option-content">
                    <span class="option-title">${subscriptionTitle}</span>
                    <div class="delivery-policy">Every 30 days</div>
                  </div>
                  <span class="discount-badge">Save 15%</span>
                  <div class="price-container">
                    <span class="original-price">$34.99</span>
                    <span class="discounted-price">$29.74</span>
                  </div>
                </label>
              </form>
              <div class="modal-policy">
                <small>By clicking Add to Order, you're adding this item to your subscription. You'll be charged automatically at the listed price and frequency until canceled.</small>
              </div>
              <div class="modal-footer">
                <button class="primary-button" type="button">ADD TO ORDER</button>
                <button class="secondary-button" type="button">Cancel</button>
              </div>
            </div>
          </div>
        `
        : html`
          <div class="callout" style="margin-bottom: 16px;">
            <h3>Resume Your Subscription</h3>
            <small>Your subscription is currently paused. Resume it to receive your next order.</small>
            <button class="callout-button" type="button">Resume Subscription</button>
          </div>

          <div class="debug-modal-preview">
            <div class="modal-content">
              <div class="modal-header">
                <h2 class="modal-title">Resume Your Subscription</h2>
                <button class="close-button" type="button">&times;</button>
              </div>
              <div class="modal-body">
                <p>Your subscription will be resumed and your next order will be scheduled automatically.</p>
              </div>
              <div class="modal-footer">
                <button class="primary-button" type="button">RESUME SUBSCRIPTION</button>
                <button class="secondary-button" type="button">Cancel</button>
              </div>
            </div>
          </div>
        `}
    </div>
  `;
}
}

customElements.define("skio-add-to-subscription", SkioAddToSubscription);
